export default class Wiz {
    public namespace = '';
    public baseuri: string;

    constructor(baseuri: string) {
        this.baseuri = baseuri;
    }

    public app(namespace: string) {
        const instance = new Wiz(this.baseuri);
        instance.namespace = namespace;
        return instance;
    }

    private cookie(name: string) {
        const prefix = `${name}=`;
        const item = document.cookie
            .split(';')
            .map((value) => value.trim())
            .find((value) => value.startsWith(prefix));
        return item ? item.slice(prefix.length) : '';
    }

    public dev() {
        return this.cookie('season-wiz-devmode') === 'true';
    }

    public project() {
        return this.cookie('season-wiz-project') || 'main';
    }

    public url(functionName: string) {
        const name = functionName.replace(/^\//, '');
        return `${this.baseuri}/api/${this.namespace}/${name}`;
    }

    public async call(functionName: string, data: Record<string, any> = {}) {
        const body = new URLSearchParams();
        for (const [key, value] of Object.entries(data)) {
            body.set(key, String(value));
        }

        const response = await fetch(this.url(functionName), {
            method: 'POST',
            body
        });

        return response.json();
    }
}
